import { modifier } from 'ember-modifier'

export default modifier((element: HTMLElement) => {
  const stop = (event: Event): void => event.stopPropagation()

  element.addEventListener('click', stop)

  return () => element.removeEventListener('click', stop)
})
